module.exports = __webpack_public_path__ + "media/images/suppliers/biocheck-292c5738941bfeb472c57f0c0beb96a4.png";